// src/pages/Swap/utils/SwapConstants.js
// Constants and helper functions for the Swap functionality
import i18n from '../../../i18n';

// Special ETH address used by BitDogSwap for native tokens
export const ETH_ADDRESS = "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE";

// BitDogSwap Aggregator ABI with only the functions we need
export const BITDOG_SWAP_ABI = [
  "function getTokenToEthQuote(address tokenIn, uint256 amountIn) external view returns (address bestRouter, uint256 estimatedEth)",
  "function getEthToTokenQuote(address tokenOut, uint256 amountIn) external view returns (address bestRouter, uint256 estimatedTokens)",
  "function getTokenToTokenQuote(address tokenIn, address tokenOut, uint256 amountIn) external view returns (address sourceRouter, address destRouter, uint256 estimatedTokens)",
  "function swap(address tokenIn, address tokenOut, uint256 amountIn, uint256 amountOutMin, uint256 deadline) external payable returns (uint256 amountReceived)"
];

// ERC-20 Token ABI - for token approvals
export const ERC20_ABI = [
  "function approve(address spender, uint256 amount) external returns (bool)",
  "function allowance(address owner, address spender) external view returns (uint256)"
];

// Helper function to get translations
const t = (key) => {
  return i18n.t(key);
};

// Helper function to create a native token object from a chain configuration
export const createNativeTokenFromChain = (chain) => {
  if (!chain || !chain.nativeToken) {
    console.error(t('swap.constants.invalidChainConfig'));
    return null;
  }
  
  return {
    symbol: chain.nativeToken.symbol,
    address: ETH_ADDRESS,
    name: chain.nativeToken.name,
    decimals: chain.nativeToken.decimals || 18,
    icon: chain.nativeToken.icon
  };
};

// Generic token selection placeholder
export const selectPlaceholder = {
  symbol: '',
  address: '',
  name: t('swap.constants.selectToken'),
  decimals: 18,
  icon: ''
};

// Update placeholder when language changes
i18n.on('languageChanged', () => {
  selectPlaceholder.name = t('swap.constants.selectToken');
});